/** @format */

import CardRoom from '@/components/page/PageListing/components/CardRoom';
import { PopupPosition } from '@/ducks/map/hooks/useMap';
import React from 'react';
import { Popup } from 'react-map-gl';
import { TRoom } from '../../../@ducks/room/declarations';
import type { Coords, TBuildingRoomsMarker, TRoomMarker } from '../../../api/apiListingMapMarkers';
import { useRoomQuery } from '../../../queries/useRoomQuery';
import { CardRoomSkeleton } from '../../page/PageListing/components/CardRoomSkeleton';
import { PopupContent } from './MapPopup.style';

const SingleRoomPopup = ({
  code,
  position,
  coords,
  setPopupInfo,
  offset,
}: {
  code: string;
  position: PopupPosition;
  coords: Coords;
  setPopupInfo: React.Dispatch<React.SetStateAction<((TRoomMarker | TBuildingRoomsMarker) & { id: string }) | null>>;
  offset: [number, number];
}) => {
  const { data, isPending, isError } = useRoomQuery(code);

  return (
    <Popup
      maxWidth={'20.5rem'}
      anchor={position}
      longitude={Number(coords.longitude)}
      latitude={Number(coords.latitude)}
      onClose={() => setPopupInfo(null)}
      offset={offset}
    >
      <PopupContent>
        {isPending || isError ? <CardRoomSkeleton /> : <CardRoom room={data as TRoom} isPopup />}
      </PopupContent>
    </Popup>
  );
};

export default SingleRoomPopup;
